module.exports = __webpack_public_path__ + "static/img/4.61126e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-de/4.jpg
// module id = LGVd
// module chunks = 1